/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_NoInputs */

const vi_einvoice_manual_no = /** @type {(inputs: Einvoice_Manual_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số hóa đơn`)
};

/**

* @param {Einvoice_Manual_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_no = /** @type {((inputs?: Einvoice_Manual_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_no(inputs)
});